import { useLocalStorage } from 'usehooks-ts'

/**
 * Hook to manage the "platform-notification-seen" local storage state.
 * This is used to track whether the user has seen the platform notification.
 * It gets reset on each login.
 */
export default function usePlatformNotificationSeen() {
  return useLocalStorage('platform-notification-seen', false)
}
